import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Target, Crosshair, ShieldCheck } from 'lucide-react';
export function SolutionSection() {
  const solutions = [{
    icon: <Brain className="w-8 h-8 text-blue-400" data-id="element-123" />,
    title: 'Pensá como un ADC ganador',
    desc: 'Dejá de jugar en piloto automático. Aprendé a leer el mapa y anticipar el peligro antes de que suceda.'
  }, {
    icon: <Target className="w-8 h-8 text-green-400" data-id="element-124" />,
    title: 'Controlá las oleadas con propósito',
    desc: 'Dominá el freeze, slow push y fast push para denegar oro al rival y crear oportunidades de kill.'
  }, {
    icon: <Crosshair className="w-8 h-8 text-red-400" data-id="element-125" />,
    title: 'Decidí mejor bajo presión',
    desc: 'Tablas de decisión claras para saber exactamente qué hacer en cada momento de la partida.'
  }, {
    icon: <ShieldCheck className="w-8 h-8 text-amber-400" data-id="element-126" />,
    title: 'Sobreviví e impactá',
    desc: 'Posicionamiento avanzado para hacer el máximo daño posible sin regalar tu vida.'
  }];
  return <section className="py-20 bg-[#0a0a0a] relative" data-id="element-127">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-20 pointer-events-none" data-id="element-128" />

      <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-129">
        <div className="text-center mb-16" data-id="element-130">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6 uppercase tracking-tight" data-id="element-131">
            Un sistema completo para{' '}
            <span className="text-amber-500" data-id="element-132">ganar como ADC</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-133">
            Este no es otro libro de teoría aburrida. Es un sistema paso a paso
            diseñado para transformar tu forma de ver el juego.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-134">
          {solutions.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#111] p-8 rounded-2xl border border-gray-800 hover:border-gray-600 transition-all group" data-id="element-135">
              <div className="bg-gray-800/50 w-16 h-16 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 border border-gray-700" data-id="element-136">
                {item.icon}
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-137">
                {item.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-138">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}